export enum SectionKey {
  PATIENT = 'patient',
  APPOINTMENT = 'appointment',
  FULFILLMENT = 'fulfillment',
  CATEGORIES = 'categories',
}
